import * as React from 'react'
import { CommandItem } from '@/components/ui/command'
import {
	User,
	Building2,
	FileText,
	Receipt,
	FolderKanban,
	Package,
	ArrowRightLeft,
	Banknote,
	CircleCheck,
	FormInput,
	FileSignature,
	ScrollText,
	ListTodo,
	Send,
	CornerDownLeft,
} from 'lucide-react'

export enum SearchItemTypes {
	person = 'person',
	company = 'company',
	contact = 'contact',
	credit_note = 'credit_note',
	expense = 'expense',
	order_form = 'order_form',
	delivery_note = 'delivery_note',
	invoice = 'invoice',
	recurring_invoice = 'recurring_invoice',
	project = 'project',
	quotation = 'quotation',
	product = 'product',
	service = 'service',
	transaction = 'transaction',
	payment = 'payment',
	deal = 'deal',
	form = 'form',
	proposal = 'proposal',
	contract = 'contract',
	task = 'task',
	sequence = 'sequence'
}

const SEARCH_TYPE_ICONS: Record<SearchItemTypes, React.ComponentType<{ className?: string }>> = {
	[SearchItemTypes.person]: User,
	[SearchItemTypes.company]: Building2,
	[SearchItemTypes.contact]: User,
	[SearchItemTypes.order_form]: FileText,
	[SearchItemTypes.delivery_note]: FileText,
	[SearchItemTypes.credit_note]: FileText,
	[SearchItemTypes.expense]: Receipt,
	[SearchItemTypes.invoice]: FileText,
	[SearchItemTypes.recurring_invoice]: FileText,
	[SearchItemTypes.project]: FolderKanban,
	[SearchItemTypes.quotation]: FileText,
	[SearchItemTypes.product]: Package,
	[SearchItemTypes.service]: Package,
	[SearchItemTypes.transaction]: ArrowRightLeft,
	[SearchItemTypes.payment]: Banknote,
	[SearchItemTypes.deal]: CircleCheck,
	[SearchItemTypes.form]: FormInput,
	[SearchItemTypes.proposal]: FileSignature,
	[SearchItemTypes.contract]: ScrollText,
	[SearchItemTypes.task]: ListTodo,
	[SearchItemTypes.sequence]: Send,
}

type IProps = {
	value: string
	title: React.ReactNode
	type?: SearchItemTypes
	icon?: React.ComponentType<{ className?: string }>
	onSelect: () => void
}

export default function SearchItem({ value, title, type, icon, onSelect }: IProps) {
	const TypeIcon = icon ?? SEARCH_TYPE_ICONS[type]

	return (
		<CommandItem value={value} onSelect={onSelect} className="group">
			{TypeIcon && <TypeIcon />}
			<span className="flex-1 truncate">{title}</span>
			<CornerDownLeft className="ml-auto hidden size-3.5 shrink-0 group-data-[selected=true]:block" />
		</CommandItem>
	)
}
